import React from "react";

type ContentCardProps = {
  children: React.ReactNode;
  title: string;
};

const ContentCard = ({ children, title }: ContentCardProps) => {
  return (
    <section className="rounded-lg bg-white p-6 shadow-md">
      <h2 className="mb-4 text-2xl font-semibold text-gray-900">{title}</h2>
      <div className="space-y-4 leading-7">{children}</div>
    </section>
  );
};

export default ContentCard;
